module.exports = __webpack_public_path__ + "static/media/GAMKONORA_ch1_20210921025649_T.6c125b91.jpg";